import React from 'react';
import { Col, Button } from 'reactstrap';
import Image from "../../../common/image";
import Icon from "../../../common/icon";
export default (function (_ref) {
  var responses = _ref.responses,
    locale = _ref.locale,
    indexRow = _ref.indexRow,
    mode = _ref.mode,
    onChange = _ref.onChange,
    excluded = _ref.excluded;
  if (!responses) {
    return null;
  }
  return responses.map(function (response, indexResponse) {
    if (response.checked !== undefined && false === response.checked || Array.isArray(excluded) && excluded.includes(response.alias)) {
      return null;
    }
    var isSelected = response.alias === mode;
    return /*#__PURE__*/React.createElement(Col, {
      className: "journey tag align-self-center col-auto checkbox-tag",
      key: "".concat(indexResponse, "_").concat(response.alias)
    }, /*#__PURE__*/React.createElement(Button, {
      className: "mb-0 collectorCheckboxTag ".concat(response.icon ? 'icon-owner' : '', " ").concat(isSelected ? 'active' : ''),
      onClick: function onClick() {
        return onChange(response.alias, indexRow);
      }
    }, response.iconSvg ? /*#__PURE__*/React.createElement(Image, {
      name: response.iconSvg,
      label: null
    }) : response.icon ? /*#__PURE__*/React.createElement(Icon, {
      className: "icon",
      name: response.icon
    }) : '', response.name[locale]));
  });
});